import React from "react";
import { HOTMART_URL } from "../../lib/constants";
import { ArrowRight, ShieldCheck } from "lucide-react";

export default function FinalPush() {
  return (
    <section
      className="relative py-24 sm:py-32 bg-[#0A0A0A] overflow-hidden"
      data-testid="final-push-section"
    >
      <div aria-hidden="true" className="absolute inset-0 grain" />
      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <p className="font-display text-3xl sm:text-4xl md:text-5xl text-white leading-tight">
          Alguns esperam. <br />
          <span className="text-yellow-400">Outros decidem.</span>
        </p>

        <a
          href={HOTMART_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="final-push-cta"
          className="mt-10 group inline-flex items-center justify-center gap-3 bg-yellow-400 hover:bg-yellow-300 text-black font-display tracking-wide text-xl sm:text-2xl px-10 py-6 transition-colors"
        >
          QUERO MEU CARTÃO SIGO
          <ArrowRight className="w-6 h-6 transition-transform group-hover:translate-x-1" />
        </a>

        <p className="mt-6 text-xs uppercase tracking-[0.3em] text-zinc-500 flex items-center justify-center gap-2">
          <ShieldCheck className="w-3.5 h-3.5 text-yellow-400" />
          Garantia blindada de 14 dias · Risco zero
        </p>
      </div>
    </section>
  );
}
